import { render, staticRenderFns } from "./communityIssueArea.vue?vue&type=template&id=217e9a9e&scoped=true&lang=pug&"
import script from "./communityIssueArea.vue?vue&type=script&lang=js&"
export * from "./communityIssueArea.vue?vue&type=script&lang=js&"
import style0 from "./communityIssueArea.vue?vue&type=style&index=0&id=217e9a9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217e9a9e",
  null
  
)

export default component.exports